export const Unreachable = (reason = 'unreachable code here') => {
    throw new Error(reason);
};
